import { toast } from "react-toastify";
import { useInspectionClient } from "./useInspectionClient";

export const usePostFileForm = (
  endpoint: string
) => {
    const client = useInspectionClient();
  const postForm = async (data: FormData, callback: Function) => {
    try {
      // Write input to log
      console.log("Input values", data);
const endpointResponse = client.api(endpoint).tokenOptions.baseUrl;
console.log('upload file endpoint', endpointResponse)
var myHeaders = new Headers();
myHeaders.append("accept", "*/*");

var requestOptions = {
method: 'POST',
headers: myHeaders,
body: data
};

fetch(`${endpointResponse}/${endpoint}`, requestOptions)
    .then(response => response.text())
    .then(result => {callback(result)})
    .catch(error => {callback(error)});
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  return postForm;
};

export default usePostFileForm;
